<template>
<AppLayout>
  <div class="inventory">
    <section id="purchase-request-add">
      <div class="container">
        <!--<h5>Purchase Requisition</h5>-->
        <form @submit.prevent="savePurchaseRequest">
          <div class="form">
            <div class="row">
              <div class="fw-bold">1. Request Information</div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Department (optional)</label>
                  <select v-model="form.department" class="form-control">
                    <option value="">-- None --</option>
                    <option v-for="d in departments" :key="d.id" :value="d.name">{{ d.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Category</label>
                  <select v-model="form.procurementCategoryId" class="form-control">
                    <option value="">Select Category</option>
                    <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
                  </select>
                  <span v-if="errors.procurementCategoryId" class="text-danger">{{ errors.procurementCategoryId }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Project (optional)</label>
                  <select v-model="form.project" class="full" id="projects" v-if="projects?.length > 0">
                    <option v-for="proj in projects" v-bind:Key="proj.id" :value="proj.name">{{ proj.name }}</option>
                  </select>
                </div>
              </div>
              <!-- Requested To removed -->
              <div class="col-md-2">
                <div class="form-group">
                  <label>Priority</label>
                  <select v-model="form.priority" class="form-control">
                    <option value="MEDIUM">Medium</option>
                    <option value="LOW">Low</option>
                    <option value="HIGH">High</option>
                    <option value="URGENT">Urgent</option>
                  </select>
                  <span v-if="errors.priority" class="text-danger">{{ errors.priority }}</span>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Expected Date</label>
                  <input type="date" v-model="form.expectedDate" class="form-control" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Purpose</label>
                  <input type="text" v-model="form.purpose" class="form-control" />
                </div>
              </div>
            </div>
            <div class="form">
              <!--
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea v-model="form.description" class="form-control" rows="1" placeholder="Additional details..."></textarea>
                </div>
              </div>
            </div>-->
          </div>
          </div>
          <div class="form">
            <div class="row mt-3">
              <div class="fw-bold">2. Add Items</div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Product</label>
                    <select v-model="newItem.productId" @change="updateProductInfo(newItem)" class="form-control">
                      <option value="">Select Product</option>
                      <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Unit</label>
                    <input type="text" v-model="newItem.unit" class="form-control" readonly />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Quantity</label>
                    <input type="number" min="1" v-model.number="newItem.quantity" class="form-control" />
                    <small v-if="selectedProduct">
                      Available: <strong>{{ selectedProduct.availableQuantity }}</strong>
                    </small>
                  </div>
                </div>

                <!--
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Avg Weighted Price</label>
                    <input type="text" :value="selectedProduct ? formatMoney(selectedProduct.avgWeightedPrice) : ''" class="form-control" readonly />
                  </div>
                </div>-->
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Notes</label>
                    <input type="text" v-model="newItem.notes" class="form-control" />
                  </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                    <label>&ensp;</label>
                    <button type="button" style="margin-top: 30px !important" class="btn btn-small btn-style-2" @click="addItem">Add</button>
                  </div>
                </div>
              </div>
              <table v-if="form.items.length > 0" class="table table-hover mt-3">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Product</th>
                    <th>Unit</th>
                    <th>Qty</th>
                    <th>Notes</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="form.items.length > 0">
                  <tr v-for="(item, idx) in filteredItems" :key="idx">
                    <td>{{ idx + 1 }}</td>
                    <td>{{ item.productId ? (products.find(p => p.id === item.productId)?.name || '') : '' }}</td>
                    <td>{{ item.unit || '' }}</td>
                    <td>{{ item.quantity || '' }}</td>
                    <td>{{ item.notes || '' }}</td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm" @click="removeItem(idx)">Remove</button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr><td colspan="6" class="text-center">No items added</td></tr>
                </tbody>
              </table>
            </div>
          </div>
         
          <div class="form-actions d-flex justify-content-end mt-3">
            <button type="submit" class="btn btn-outline-secondary" :disabled="saving">
              <span v-if="saving">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Submitting...
              </span>
              <span v-else>Submit Request</span>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</AppLayout>
</template>
<script>

import AppLayout from '@/components/AppLayout.vue'
import { toast } from 'vue3-toastify';
import { mapGetters, mapActions } from 'vuex'
const BASE_URL = process.env.VUE_APP_URL;

export default {
  name: 'PurchaseRequestForm',
  components: { AppLayout },

  data() {
    return {
      form: {
        department: '',
        project: '',
        procurementCategoryId: '',
        priority: 'MEDIUM',
        expectedDate: '',
        purpose: '',
        description: '',
        items: []
      },
      newItem: {
        productId: '',
        unit: '',
        quantity: 1,
        notes: ''
      },
      products: [],
      categories: [],
      errors: {},
      saving: false,
      isEdit: false,
      requestId: null
    }
  },
  computed: {
    ...mapGetters(["getProjects", "getDepartments"]),
    filteredItems() {
      return this.form.items.filter(i => i !== undefined && i !== null);
    },
    selectedProduct() {
      return this.products.find(p => p.id === this.newItem.productId) || null;
    },
    projects() { return this.getProjects || [] },
    departments() { return this.getDepartments || [] }
  },

  mounted() {
    this.fetchDepartments()
    this.fetchProjects()
    this.loadProducts()
    this.loadCategories()

    if (this.$route.params.id) {
      this.isEdit = true
      this.requestId = this.$route.params.id
      this.loadPurchaseRequest()
    }
  },

  methods: {

    ...mapActions(["fetchProjects", "fetchDepartments"]),

    

    async loadProducts() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const res = await fetch(`${BASE_URL}/products`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        this.products = await res.json();
      } catch {
        console.log('Failed to load products');
      }
    },

    async loadCategories() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const res = await fetch(`${BASE_URL}/tender-category`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        const result = await res.json();
        // Use result.data if API returns { status, data }
        this.categories = Array.isArray(result.data) ? result.data : result;
      } catch {
        console.log('Failed to load tender categories');
      }
    },

    async loadPurchaseRequest() {
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        const res = await fetch(`${BASE_URL}/purchase-requests/${this.requestId}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        const resp = await res.json();
        const r = resp.data || resp;

        // If the request exists but is not pending, do not allow editing
        const status = (r.status || '').toString().toUpperCase();
        if (status !== 'PENDING') {
          toast.error('Only pending purchase requests can be edited');
          this.$router.push('/transaction/purchase-request');
          return;
        }

        this.form = {
          department: r.department || r.department || '',
          project: r.project || r.project || '',
          procurementCategoryId: r.procurementCategoryId || r.categoryId,
          priority: r.priority || r.urgency || 'MEDIUM',
          expectedDate: r.expectedDate?.split('T')[0] || r.expectedDeliveryDate?.split('T')[0] || '',
          purpose: r.purpose || r.justification || '',
          description: r.description || '',
          items: (r.items || []).map(i => ({
            id: i.id,
            productId: i.productId,
            quantity: i.quantity,
            unit: i.product?.unit?.name || '',
            notes: i.notes || ''
          }))
        };
      } catch {
        console.log('Failed to load purchase request');
        this.$router.push('/transaction/purchase-request');
      }
    },

    addItem() {
      // Validate newItem before adding
      if (!this.newItem.productId) {
        toast.error('Select a product');
        return;
      }
      if (!this.newItem.quantity || this.newItem.quantity < 1) {
        toast.error('Enter a valid quantity');
        return;
      }
      // Push a copy to avoid reference issues
      this.form.items.push({
        productId: this.newItem.productId,
        unit: this.newItem.unit,
        quantity: this.newItem.quantity,
        notes: this.newItem.notes
      });
      // Reset newItem
      this.newItem = {
        productId: '',
        unit: '',
        quantity: 1,
        notes: ''
      };
    },

    removeItem(index) {
      this.form.items.splice(index, 1)
    },

    updateProductInfo(item) {
      const p = this.products.find(x => x.id === item.productId)
      if (p) item.unit = p.unit?.name || ''
    },

    validateForm() {
      this.errors = {}

      if (!this.form.procurementCategoryId) this.errors.procurementCategoryId = 'Category is required'
      if (!this.form.priority) this.errors.priority = 'Priority is required'

      if (!this.form.items.length) {
        toast.error('Add at least one item')
        return false
      }

      this.form.items.forEach((i, idx) => {
        if (!i.productId) this.errors[`items.${idx}.productId`] = 'Product required'
        if (!i.quantity || i.quantity <= 0)
          this.errors[`items.${idx}.quantity`] = 'Invalid quantity'
      })

      return Object.keys(this.errors).length === 0
    },

    async savePurchaseRequest() {
      if (!this.validateForm()) return;
      this.saving = true;
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        // Map frontend fields to backend DTO
        const payload = {
          title: 'Purchase Request', // You may want to add a title input in the form and use it here
          department: this.form.department || undefined,
          project: this.form.project || undefined,
          procurementCategoryId: this.form.procurementCategoryId ? Number(this.form.procurementCategoryId) : undefined,
          urgency: this.form.priority ? this.form.priority.toLowerCase() : undefined,
          expectedDeliveryDate: this.form.expectedDate || undefined,
          justification: this.form.purpose || undefined,
          description: this.form.description || undefined,
          items: this.form.items.map(i => ({
            productId: i.productId ? Number(i.productId) : undefined,
            quantity: i.quantity ? Number(i.quantity) : 1,
            // Optionally add more fields if available
          })),
        };
        let res;
        if (this.isEdit) {
          res = await fetch(`${BASE_URL}/purchase-requests/${this.requestId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        } else {
          res = await fetch(`${BASE_URL}/purchase-requests`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        }
        if (res.ok) {
          toast.success('Purchase request saved');
          this.$router.push('/transaction/purchase-request');
        } else {
          toast.error('Failed to save purchase request');
        }
      } catch {
        toast.error('Failed to save purchase request');
      } finally {
        this.saving = false;
      }
    },

    async saveDraft() {
      this.saving = true;
      try {
        const token = JSON.parse(localStorage.getItem('access_token'));
        // Map frontend fields to backend DTO
        const payload = {
          title: 'Purchase Request', // You may want to add a title input in the form and use it here
          department: this.form.department || undefined,
          project: this.form.project || undefined,
          procurementCategoryId: this.form.procurementCategoryId ? Number(this.form.procurementCategoryId) : undefined,
          urgency: this.form.priority ? this.form.priority.toLowerCase() : undefined,
          expectedDeliveryDate: this.form.expectedDate || undefined,
          justification: this.form.purpose || undefined,
          description: this.form.description || undefined,
          items: this.form.items.map(i => ({
            productId: i.productId ? Number(i.productId) : undefined,
            quantity: i.quantity ? Number(i.quantity) : 1,
            // Optionally add more fields if available
          })),
        };
        let res;
        if (this.isEdit) {
          res = await fetch(`${BASE_URL}/purchase-requests/${this.requestId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        } else {
          res = await fetch(`${BASE_URL}/purchase-requests`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify(payload)
          });
        }
        if (res.ok) {
          toast.success('Draft saved');
          this.$router.push('/transaction/purchase-request');
        } else {
          toast.error('Failed to save draft');
        }
      } finally {
        this.saving = false;
      }
    }
  }
}
</script>
